(function() {
  // Configurable minimum items required for checkout
  const MIN_BUNDLE_QTY = 5;

  // Insert custom CSS for warning banner dynamically
  const style = document.createElement('style');
  style.innerHTML = `
    .bundle-cart-warning {
          background-color: #FFF5F4;
        border: 1.5px solid #BC3227;
        border-radius: 12px;
        padding: 4px 5px;
        margin: 0 0 15px 0;
        color: #3E2415;
        font-family: 'Manrope', sans-serif;
        display: flex;
        align-items: center;
        gap: 10px;
        text-align: left;
        box-shadow: 0 2px 8px rgba(188, 50, 39, 0.08);
        font-weight: 300;
        font-size: 1.2rem;
        line-height: 1.5;
    }
    .bundle-cart-warning svg {
      width: 20px;
      height: 20px;
      fill: #BC3227;
      flex-shrink: 0;
    }
    /* Style disabled button pointer events */
    button[name="checkout"]:disabled, 
    input[name="checkout"]:disabled, 
    .cart-checkout-btn:disabled {
      background-color: #E2DDD5 !important;
      color: #8E8A85 !important;
      cursor: not-allowed !important;
      opacity: 0.8 !important;
      pointer-events: none !important;
    }
  `;
  document.head.appendChild(style);

  // Main Validation function
  function validateBundleCart() {
    fetch('/cart.js')
      .then(response => {
        if (!response.ok) throw new Error('Failed to fetch cart');
        return response.json();
      })
      .then(cart => {
        let totalBundleQty = 0;

        // Loop through all items in the cart to check for properties._bundle_builder
        if (cart && cart.items) {
          cart.items.forEach(item => {
            if (item.properties && item.properties._bundle_builder === 'true') {
              totalBundleQty += item.quantity;
            }
          });
        }

        const isBypassingLimit = totalBundleQty > 0 && totalBundleQty < MIN_BUNDLE_QTY;
        toggleCheckoutBlock(isBypassingLimit, totalBundleQty);
      })
      .catch(error => {
        console.error('Error validating bundle cart:', error);
      });
  }

  // Disable / Enable checkout buttons and add visual banners
  function toggleCheckoutBlock(blockCheckout, totalBundleQty) {
    // Select all potential checkout buttons in the header cart drawer, cart page, etc.
    const checkoutButtons = document.querySelectorAll('button[name="checkout"], input[name="checkout"], a[href="/checkout"], #checkout, .cart__checkout-button');
    const cartForms = document.querySelectorAll('form[action="/cart"], form[action*="/cart"]');

    if (blockCheckout) {
      // 1. Disable checkout buttons
      checkoutButtons.forEach(btn => {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        // Prevent anchor links from firing redirects
        if (btn.tagName === 'A') {
          btn.addEventListener('click', preventDefaultAction);
          btn.style.pointerEvents = 'none';
        }
      });

      // 2. Prevent form submission
      cartForms.forEach(form => {
        form.removeEventListener('submit', preventDefaultAction);
        form.addEventListener('submit', preventDefaultAction);
      });

      // 3. Inject warning banner before checkout buttons
      checkoutButtons.forEach(btn => {
        // Find existing banner associated with this button's parent
        const parent = btn.parentNode;
        let existingWarning = parent.querySelector('.bundle-cart-warning');
        
        if (!existingWarning) {
          const warning = document.createElement('div');
          warning.className = 'bundle-cart-warning';
          warning.innerHTML = `
            <svg viewBox="0 0 24 24">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
            </svg>
            <div>
              <strong>Bundle Gate:</strong> Minimum of ${MIN_BUNDLE_QTY} units is required to purchase a custom bundle. 
              Please add <strong>${MIN_BUNDLE_QTY - totalBundleQty} more sachet(s)</strong> to checkout.
            </div>
          `;
          parent.insertBefore(warning, btn);
        } else {
          // Update number of items needed
          const textDiv = existingWarning.querySelector('div');
          if (textDiv) {
            textDiv.innerHTML = `
              <strong>Bundle Gate:</strong> Minimum of ${MIN_BUNDLE_QTY} units is required to purchase a custom bundle. 
              Please add <strong>${MIN_BUNDLE_QTY - totalBundleQty} more sachet(s)</strong> to checkout.
            `;
          }
        }
      });

    } else {
      // 1. Re-enable checkout buttons
      checkoutButtons.forEach(btn => {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        if (btn.tagName === 'A') {
          btn.removeEventListener('click', preventDefaultAction);
          btn.style.pointerEvents = '';
        }
      });

      // 2. Remove submit blockers
      cartForms.forEach(form => {
        form.removeEventListener('submit', preventDefaultAction);
      });

      // 3. Remove warning banners
      document.querySelectorAll('.bundle-cart-warning').forEach(el => el.remove());
    }
  }

  function preventDefaultAction(e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }

  // --- AJAX CART LISTENERS ---
  // Hook 1: Fetch API
  if (window.fetch) {
    const originalFetch = window.fetch;
    window.fetch = function() {
      return originalFetch.apply(this, arguments).then(response => {
        const url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
        if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear') || url.includes('main-cart') || url.includes('cart-drawer')) {
          setTimeout(validateBundleCart, 500); // Brief delay for theme DOM updates
        }
        return response;
      });
    };
  }

  // Hook 2: XMLHttpRequests (XHR)
  const originalXHRSend = window.XMLHttpRequest.prototype.send;
  window.XMLHttpRequest.prototype.send = function() {
    this.addEventListener('load', function() {
      const url = this._url || '';
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
        setTimeout(validateBundleCart, 500);
      }
    });
    return originalXHRSend.apply(this, arguments);
  };

  const originalXHROpen = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    return originalXHROpen.apply(this, arguments);
  };

  // Hook 3: jQuery Ajax (if theme is utilizing jQuery)
  if (window.jQuery) {
    window.jQuery(document).ajaxComplete(function(event, xhr, settings) {
      if (settings.url && (settings.url.includes('/cart/add') || settings.url.includes('/cart/change') || settings.url.includes('/cart/update') || settings.url.includes('/cart/clear'))) {
        setTimeout(validateBundleCart, 500);
      }
    });
  }

  // Run validation on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', validateBundleCart);
  } else {
    validateBundleCart();
  }
})();
